import { Chip } from "@/components/strategy/Chip";

export const TONE_OPTIONS = [
    "Casual",
    "Humorous",
    "Authoritative",
    "Inspirational",
    "Educational",
    "Bold",
];

export default function Step3Audience({ form, updateField, toggleArrayField }) {
    const toneCap = form.tone.length >= 3;
    return (
        <div
            className="flex flex-col gap-7"
            data-testid="strategy-step-3"
        >
            <div className="flex flex-col gap-2">
                <h3 className="text-xl font-medium text-[#E8ECF5]">
                    Who are you speaking to — and how?
                </h3>
                <p className="font-mono text-[11px] italic text-[#8A93A6]">
                    The clearer your target, the sharper the hooks.
                </p>
            </div>

            <div className="flex flex-col gap-3">
                <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8A93A6]">
                    audience
                </label>
                <input
                    type="text"
                    value={form.audience}
                    onChange={(e) => updateField("audience", e.target.value)}
                    placeholder="e.g. Gen Z, urban foodies · First-time home buyers in NYC · Indie devs"
                    data-testid="strategy-audience-input"
                    className="w-full rounded-xl border border-[#1F2A40] bg-[#111726] px-4 py-3 text-sm text-[#E8ECF5] placeholder:text-[#8A93A6] transition-all focus:border-[#2F58CD] focus:outline-none focus:ring-1 focus:ring-[#2F58CD]/40"
                />
            </div>

            <div className="flex flex-col gap-3">
                <div className="flex items-end justify-between gap-2">
                    <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8A93A6]">
                        tone · pick 1–3
                    </label>
                    <span
                        className="font-mono text-[10px] tabular-nums text-[#8A93A6]"
                        data-testid="strategy-tone-count"
                    >
                        {form.tone.length}/3
                    </span>
                </div>
                <div
                    className="flex flex-wrap gap-2"
                    data-testid="strategy-tone-group"
                >
                    {TONE_OPTIONS.map((t) => (
                        <Chip
                            key={t}
                            label={t}
                            selected={form.tone.includes(t)}
                            disabled={toneCap && !form.tone.includes(t)}
                            onToggle={() => toggleArrayField("tone", t, 3)}
                            testId={`strategy-tone-${t.toLowerCase()}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
